import React, { Fragment } from 'react';
import { AppState } from 'core/redux/reducers';
import { selectTranslator, TransFn } from 'core/redux/features/languages/trans';
import { connect } from 'react-redux';
// import { hot } from 'react-hot-loader/root';
import { CheckoutOrder } from 'core/redux/features/shared/types';
import numberFormat from 'core/utils/numberFormat';
import { TextLoading } from '../Loaders';

const LineItemSkeleton = () => (
  <TextLoading
    height={12}
    backgroundColor="#3d414d"
    foregroundColor="#343842"
  />
);

function LineItem(props: {
  type: string;
  trans: TransFn;
  order: CheckoutOrder;
}) {
  const lineItems = props.order.line_items;
  if (props.type === 'menus') {
    const normalPrice = lineItems.find(item => item.type === 'normal_price');
    const salePrice = lineItems.find(item => item.type === 'total_amount');
    if (!normalPrice || !salePrice) {
      return null;
    }

    return (
      <div className="line-items__item" id={props.type}>
        <div>{props.trans('line_item.menus')}</div>
        <div className="amount has-text-right">
          <del>{normalPrice.amount} KR </del>
          {salePrice.amount} KR
        </div>
      </div>
    );
  } else if (props.type === 'payment_total') {
    return (
      <div className="line-items__item" id={props.type}>
        <div>{props.trans(`line_item.${props.type}`)}</div>
        <div className="amount has-text-right">{props.order.total} KR</div>
      </div>
    );
  } else if (props.type === 'giftcode') {
    const giftcodes = props.order.line_items.filter(
      item => item.type === 'giftcard',
    );
    if (giftcodes.length > 0) {
      return (
        <Fragment>
          {giftcodes.map((item, itemIndex) => {
            return (
              <div className="line-items__item" id={props.type} key={itemIndex}>
                <div>{props.trans(`line_item.${props.type}`)}</div>
                <div className="amount has-text-right">{item.amount} KR</div>
              </div>
            );
          })}
        </Fragment>
      );
    }
  }

  let findCards =
    props.type === 'coop' && props.order.cards
      ? props.order.cards.find(item => item.card_type === 'coop')
      : null;
  if (findCards) {
    return (
      <div className="line-items__item" id={props.type}>
        <div>{props.trans(`line_item.${props.type}`)}</div>
        <div className="amount has-text-right">{findCards.card_number}</div>
      </div>
    );
  }

  const item = props.order.line_items.find(item => item.type === props.type);
  if (item) {
    return (
      <div className="line-items__item" id={props.type}>
        <div>{props.trans(`line_item.${props.type}`)}</div>
        <div className="amount has-text-right">
          {numberFormat(item.amount)} KR
        </div>
      </div>
    );
  }

  return null;
}

const LineItemLoading = () => {
  return (
    <div className="line-items__item">
      <div style={{ width: '80%' }}>
        <LineItemSkeleton />
      </div>
      <div style={{ width: '15%' }} className="amount has-text-right">
        <LineItemSkeleton />
      </div>
    </div>
  );
};

const LoadingLineItems = React.memo(function ({
  loading,
  trans,
}: {
  loading: boolean;
  trans: TransFn;
}) {
  if (!loading) {
    return null;
  }
  return (
    <>
      <div className="title is-6 is-uppercase">{trans('order')}</div>
      <LineItemLoading />
      <LineItemLoading />
      <LineItemLoading />
      <LineItemLoading />
    </>
  );
});

const mapStateToProps = (state: AppState) => ({
  trans: selectTranslator(state),
  // loading: state.booking.loading,
  // step1: selectBookingStepData(state, BOOKING_STEP1)
});

const mapDispatchToProps = {};

interface OwnProps {
  order: CheckoutOrder;
  children: React.ReactNode;
  title: string;
  // step1: BookingStep1,
  showLineItems: boolean;
  showLineItemsLoading: boolean;
}

type TProps = OwnProps &
  Omit<ReturnType<typeof mapStateToProps>, 'step1'> &
  typeof mapDispatchToProps;

function SummaryComp(props: TProps) {
  const {
    trans,
    title,
    children,
    order,
    showLineItems,
    showLineItemsLoading,
  } = props;

  return (
    <div className="book-summary">
      <div className="content">
        <div className="title is-6 is-uppercase">{title}</div>
        {children}
        {/* <LineItem type="coop" order={order} trans={trans} /> */}
      </div>
      <hr className="is-white" />
      {showLineItems ? (
        <div className="title is-6 is-uppercase">{trans('order')}</div>
      ) : null}
      <div className="line-items">
        {showLineItems ? (
          <>
            {/*for giftcard checkout total*/}
            <LineItem type="giftcard_total" order={order} trans={trans} />
            {/*for booking checkout total*/}
            <LineItem type="menus" order={order} trans={trans} />

            <LineItem type="giftcode" order={order} trans={trans} />
            <LineItem type="admin_fee" order={order} trans={trans} />
            <LineItem type="payment_total" order={order} trans={trans} />
            <div style={{ marginTop: '20px' }} />
            <LineItem type="tax" order={order} trans={trans} />
          </>
        ) : (
          <LoadingLineItems trans={trans} loading={showLineItemsLoading} />
        )}
      </div>
    </div>
  );
}

// const StepsRoot =
//   process.env.NODE_ENV !== 'production' ? hot(SummaryComp) : SummaryComp
const CheckoutSummary = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SummaryComp);
export default CheckoutSummary;
